{
  "navigation": {
    "main": "HOME",
    "dashboard": "Übersicht",
    "issues": "Tickets",
    "inbox": "Inbox",
    "outbox": "Outbox",
    "my_issues": "Meine Tickets",
    "watching": "Beobachtete Tickets",
    "create_issue": "Ticket erstellen",
    "create_new": "Neues Ticket",
    "select_template": "Vorlagen",
    "application": "ANWENDUNG",
    "settings": "Einstellungen",
    "partnership": "Partner",
    "role_management": "Rollenverwaltung",
    "inbox_routing": "Eingangsregeln",
    "outbox_routing": "Ausgangsregeln",
    "sla_config": "SLA",
    "light_partner_config": "Light-Partner-Konfiguration",
    "help": "Hilfe",
    "release_notes": "Versionshinweise",
    "migration": "Migration"
  },
  "inbox_tickets": "Empfangene Tickets",
  "telephone": "Telefon",
  "refresh": "Aktualisieren",
  "outbox_tickets": "Gesendete Tickets",
  "my_tickets": "Meine Tickets",
  "watching_tickets": "Beobachtete Tickets",
  "error_fetching_partnership": "Fehler beim Abrufen der Partnerschaft",
  "sla_config_deleted_successfully": "Die SLA-Konfiguration wurde erfolgreich gelöscht!",
  "supported_scenarios_success": "Erfolgreich ausgewählte unterstützte Szenarien",
  "unknown_ticket_type": "Unbekannter Ticket-Typ",
  "ticket": "Ticket",
  "mark_all_as_read": "Alle als gelesen markieren",
  "no_notifications": "Es liegen keine Benachrichtigungen vor",
  "new": "neu",
  "stats": {
    "total_tickets": "Alle Tickets",
    "since_last_week": "seit letzter Woche",
    "all_time": "Gesamt",
    "this_week": "Diese Woche",
    "this_month": "Dieser Monat",
    "show_all_partners": "Alle Partner anzeigen",
    "show_top_partners": "Top {{count}} + Sonstige anzeigen",
    "filter_partner": "Partner filtern",
    "filter_partners": "Partner filtern",
    "partners_selected": "{0} Partner ausgewählt",
    "in_progress_tickets": "In Bearbeitung",
    "resolved_tickets": "Gelöste Tickets",
    "closed_tickets": "Geschlossene Tickets",
    "no_my_issues": "Ihnen sind keine Tickets zugewiesen."
  },
  "clear_filters": "Filter löschen",
  "filters": "Filter",
  "unread": "Ungelesen",
  "sla_warning": "Frist läuft ab",
  "sla_exceeded": "Frist abgelaufen",
  "deadline_warning": "Frist läuft ab",
  "deadline_exceeded": "Frist abgelaufen",
  "category": "Kategorie",
  "creation_date": "Erstellungsdatum",
  "originator": "Ersteller",
  "processor": "Empfänger",
  "severity": "Dringlichkeitsstufe",
  "finished_only": "Abgeschlossen Tickets",
  "all_tickets": "Alle Tickets",
  "active_tickets": "Aktive Tickets",
  "ticket_scope_active": "Aktive",
  "ticket_scope_all": "Alle",
  "ticket_scope_closed": "Geschlossene",
  "not_resolved_only": "Nur ungelöste Tickets",
  "status": "Aktueller Stand",
  "actions": "Aktionen",
  "partner_actions": "Partneraktionen",
  "internal_actions": "Interne Aktionen",
  "no_available_actions": "Keine verfugbaren Aktionen",
  "activity": "Aktivitäten",
  "overview": "Übersicht",
  "description": "Beschreibung",
  "status_change_reason": "Grund für Statusänderung hinzufügen",
  "status_change_date": "Datum der Statusänderung",
  "last_update": "Letzte Aktualisierung",
  "updated_short": "Aktualisiert",
  "requested_resolution_date": "Zieltermin",
  "severity_change_bnetza": "Fall-ID der 'Bundesnetzagentur'",
  "severity_change_reason": "Grund für Änderung des Eskalationsgrads",
  "resolve_attachments": "Anhänge auflösen",
  "attachments": "Anhänge",
  "no_attachments": "Es gibt keine Anhänge",
  "resolved_successfully": "Wurde das Ticket erfolgreich gelöst?",
  "resolved_successfully_short": "Erfolgreich gelöst?",
  "ticket_resolved_positively": "Positiv gelöst",
  "resolved_successfully_yes": "Erfolgreich gelöst: Ja",
  "resolved_successfully_no": "Erfolgreich gelöst: Nein",
  "ticket_resolved_unsuccessfully": "Negativ gelöst",
  "ticket_reklamiert": "Reklamiert",
  "assignee": "Zugewiesene Person",
  "any": "Beliebig",
  "no_table_tickets": "Keine Vorgänge vorhanden.",
  "total_table_tickets": "Insgesamt wurden {{ totalRecords }} Datensätze nach dem angegebenen Filter gefunden.",
  "processor_selection_required": "Empfängerauswahl erforderlich. Bitte wählen Sie einen Empfänger aus dem Dropdown-Menü, um fortzufahren.",
  "clearing_ticket": "Clearing Ticket",
  "all": "Alle",
  "notes": "Notizen",
  "internal_notes": "Interne Notizen",
  "status_changes": "Statusänderungen",
  "severity_changes": "Schweregradänderungen",
  "assignment_changes": "Zuweisungsänderungen",
  "assign_to_me": "Mir zuweisen",
  "request_cancellation": "Anfrage Stornierung",
  "successfully_requested_cancellation": "Stornierung erfolgreich angefordert",
  "watch": "Beobachten",
  "unwatch": "Nicht mehr beobachten",
  "search": "Suche",
  "critical": "Kritisch",
  "regular": "Regulär",
  "escalated": "Eskaliert",
  "acknowledged": "Eingegangen",
  "pending": "Warten auf Informationen",
  "held": "Blockiert",
  "inProgress": "In Bearbeitung",
  "cancelled": "Storniert",
  "closed": "Geschlossen",
  "resolved": "Lösung vorgeschlagen",
  "final": "Archiviert",
  "unknown_status": "Status Unbekannt",
  "create_an_issue": "Ticket erstellen",
  "scenario": "Szenario",
  "main_scenario": "Hauptszenario",
  "select_scenario": "Wählen Sie ein Szenario",
  "select_severity": "Wählen Sie eine Dringlichkeitsstufe",
  "select_processor": "Wählen Sie einen Empfänger",
  "scenario_is_mandatory": "Bitte wählen Sie ein Ticketszenario aus, um fortzufahren.",
  "mandatory": "pflicht",
  "optional": "optional",
  "external_id": "Externe ID",
  "back": "Zurück",
  "next": "Weiter",
  "submit": "Absenden",
  "details": "Details",
  "clearing_data": "Clearing Data",
  "select_originator": "Ersteller auswählen",
  "scenario_filter_placeholder": "Filtern (z. B. 2.1.08)",
  "no_matches": "Keine Treffer",
  "edit_template": "Vorlage bearbeiten",
  "save_as_template": "Als Vorlage speichern",
  "drop_files_here": "Ziehen Sie Dateien hierher, um sie hochzuladen.",
  "name": "Name",
  "no_templates": "Keine Vorlagen verfügbar.",
  "delete": "Löschen",
  "select": "Wählen Sie",
  "clearing_ticket_templates": "Vorlagen für Clearing-Tickets",
  "delete_template_confirmation": "Sind Sie sicher, dass Sie die Vorlage {{name}} löschen wollen?",
  "yes": "Ja",
  "no": "Nein",
  "successfully": "Erfolg",
  "template_deleted": "Vorlage {{name}} erfolgreich gelöscht",
  "routing_inbox": "Routing Regeln Inbox",
  "routing_outbox": "Routing Regeln Outbox",
  "create_new": "Neu erstellen",
  "routing_group": "Routing Regel",
  "active_directory_role": "App-Rolle",
  "scenarios": "Szenarien",
  "no_routing_configurations": "Keine Routing Regeln gefunden.",
  "create_routing_rule": "Routing Regel erstellen",
  "routing_group_name": "Name der Routing Regel",
  "routing_owner_name": "Name der Routing Besitzer",
  "create_additional_role": "Zusätzliche Rolle erstellen",
  "new_role_name": "Name der neuen Rolle",
  "inherited_base_role": "Geerbte Basisrolle",
  "create_role": "Rolle erstellen",
  "please_fill_required_fields": "Bitte füllen Sie alle Pflichtfelder aus",
  "no_roles_found": "Keine Rollen gefunden.",
  "role_created_success": "Rolle {{name}} erstellt.",
  "select_a_role": "Wählen Sie eine Rolle",
  "select_a_owner": "Wählen Sie Besitzer",
  "available_scenarios": "Verfügbare Szenarien",
  "selected_scenarios": "Ausgewählte Szenarien",
  "search_by_name": "Suche nach Name",
  "update": "Aktualisieren",
  "create": "Erstellen",
  "edit": "Bearbeiten",
  "delete_routing_config": "Sind Sie sicher, dass Sie {{name}} Routingregel löschen wollen?",
  "edit_routing_config": "{{name}} bearbeiten Routing-Regel",
  "partner_itu_code": "Partner ITU Code",
  "owner_itu_code": "Besitzer ITU Code",
  "scenarios_covered": "Abgedeckte Szenarien",
  "regular_resolution_time": "Reguläre Lösungszeit",
  "regular_resolution_warning_time": "Reguläre Warnzeit für Lösung",
  "critical_resolution_time": "Kritische Lösungszeit",
  "critical_resolution_warning_time": "Kritische Warnzeit für Lösung",
  "escalated_resolution_time": "Eskalierte Lösungszeit",
  "escalated_resolution_warning_time": "Eskalierte Warnzeit für Lösung",
  "no_sla_configurations": "Keine SLA Konfiguration gefunden.",
  "sla_configuration": "SLA-Konfiguration",
  "create_sla_config": "SLA-Konfiguration erstellen",
  "hours": "Stunden",
  "delete_sla_config": "Sind Sie sicher, dass Sie diese SLA-Konfiguration löschen wollen?",
  "contractNumber": "Vertragsnummer",
  "externalIdentifier": "Liste externer Identifizierungsmerkmale",
  "externalIdentifierType": "Externe Auftrags-/Identifikations-Nummer: Typ",
  "id": "externe Identifizierungsmerkmale",
  "ndc": "ONKZ",
  "phone": "Telefondaten",
  "blockPrefix": "Durchwahlrufnummer - Rufnummernblock Kopfnummer",
  "blockStart": "Rufnummernblock von",
  "blockEnd": "Rufnummernblock bis",
  "sn": "Rufnummer",
  "customer": "Kundendaten",
  "individual": "Person",
  "givenName": "Vorname",
  "familyName": "Nachname",
  "organization": "Firma",
  "tradingName": "Firmenname",
  "address": "Adressdaten",
  "requestedDate": "Kundenwunschtermin (KWT)",
  "confirmedDate": "verbindlicher Liefertermin",
  "agreedSwitchDate": "abgestimmter Wechseltermin",
  "portingDate": "Portierungsdatum (PDA)",
  "prolongationDate": "Weiterversorgen bis",
  "prolongationCompleted": "Weiterversorgung beendet",
  "prolongationChange": "Grund der Weiterversorgung",
  "initialSwitchDate": "ursprünglicher Wechseltermin",
  "troubleTicketToBeClearedCreationDate": "Erstellungsdatum Troubleticket",
  "pkiAuf": "aufnehmende Portierungskennungsinhaber (PKIauf)",
  "pkiAbg": "abgebende Portierungskennungsinhaber (PKIabg)",
  "ekpAuf": "ITU-Code des aufnehmenden Endkundenvertragspartner (EKPauf)",
  "ekpAbg": "ITU-Code des abgebenden Endkundenvertragspartner (EKPabg)",
  "nga": "Next Generation Access Betreiber",
  "additionalInformation": "Informationen/Maßnahmen/Freitext",
  "troubleTicketRequest": "Entstör-Termin",
  "error": "Fehlerdaten",
  "forbidden": {
    "summary": "Verboten",
    "detail": "Sie haben keine berechtigung, auf diese seite zuzugreifen"
  },
  "testCall": "Testanruf Daten",
  "specialAgreements": "Bilaterale Absprachen",
  "streetName": "Straße",
  "streetNr": "Hausnummer",
  "streetNrSuffix": "Hausnummernzusatz",
  "city": "Ort",
  "postcode": "Postleitzahl",
  "locality": "Ortsteil",
  "code": "Fehler-Code",
  "text": "Fehler-Text",
  "source": "Quelle",
  "destination": "Ziel",
  "timestamp": "Zeitstempel",
  "statusCode": "Auslösegrund",
  "validFor": "Entstör-Termin-Gültig für",
  "startDateTime": "Entstör-Termin (Start)",
  "endDateTime": "Entstör-Termin (Ende)",
  "externalIdentifier[externalOrderId]": "externe Auftragsnummer",
  "externalIdentifier[lineId]": "Line-ID",
  "externalIdentifier[prenegotiationId]": "VorabstimmungsID (WBCI-ID)",
  "externalIdentifier[prenegotiationChangeId]": "Storno oder TerminverschiebungsID (WBCI-ID)",
  "externalIdentifier[externalOrderIdServiceApi]": "PreOrder-ID",
  "externalIdentifier[externalOrderIdTroubleTicketApi]": "Entstörauftragsnummer",
  "externalIdentifier[technicalLineIdentifier]": "Technischer Leitungsidentifikator",
  "externalIdentifier[bnetzaId]": "Vorgangsnummer (BNetzA)",
  "externalIdentifier[homeId]": "Home-ID",
  "externalIdentifier[ONT]": "ONT-Seriennummer",
  "add_note": "Notiz hinzufügen",
  "add_internal_note": "Interne Notiz hinzufügen",
  "note_external_warning": "Grundsätzlich sind Mitteilungen ausschließlich in Ausnahmefällen für zusätzliche Hinweise an den Clearing Partner zu verwenden.\nMitteilungen werden an den jeweiligen Partner weitergeleitet und dienen ausschließlich der Kommunikation.\n\nÜber Mitteilungen dürfen keine Datenänderungen vorgenommen oder übertragen werden.\n\nEs ist jedoch möglich, per Mitteilung beispielsweise um eine Änderung des Ticket-Status auf \"Zusatzinformation anfordern\" zu bitten, damit diese Statusänderung anschließend ordnungsgemäß im System durchgeführt werden kann.",
  "note_external_warning_important": "Bitte beachten:\nDas Versenden einer Mitteilung führt zu keiner automatischen Statusänderung.",
  "note_internal_visibility": "Interne Notizen bleiben ausschließlich innerhalb der Plattform sichtbar und werden nicht an den Partner übermittelt.",
  "add_status_change_reason": "Grund für die Statusänderung hinzufügen",
  "change_ticket_severity": "Dringlichkeitsstufe ändern",
  "updated_ticket_severity": "Dringlichkeitsstufe des Clearing-Tickets aktualisiert auf {{severity}}",
  "assign_to": "Zuweisen an",
  "retry_sync": "Sync wiederholen",
  "bulk_ticket_assignment": "Bulk-Ticket-Zuweisung",
  "clearing_ticket_sync": "Synchronisierung des Clearing-Tickets",
  "logout": "Abmelden",
  "my_account": "Mein Konto",
  "update_password": "Passwort aktualisieren",
  "username": "Benutzername",
  "e_mail": "E-Mail",
  "e_mail_verified": "E-Mail verifiziert",
  "user_roles": "Benutzer-Rollen",
  "user_account_hint": "Überblick über Informationen im Zusammenhang mit der Clearing-Plattform und Verwaltung Ihres Kontos.",
  "clearing_ticket_resolution": "Clearing Ticket Lösung",
  "resolved_successfully_guideline": "\n - Wird das Anliegen des Erstellers vom Empfänger umgesetzt/erledigt, ist das Clearing-Ticket als „positiv gelöst“ zurückzumelden. \n\n - Wird das Anliegen nicht umgesetzt/erledigt oder ist es nicht gerechtfertigt, ist das Clearing-Ticket als „negativ gelöst“ zurückzumelden.",
  "clearing_ticket_resolved": "Clearing-Ticket erfolgreich gelöst",
  "clearing_ticket_unassigned": "Zuständigkeit für das Ticket erfolgreich aufgehoben",
  "clearing_ticket_assigned_to": "Erfolgreich zugewiesenes Ticket an {{username}}",
  "started_watching_ticket": "Ticket {{id}} zu beobachteten Tickets hinzugefügt",
  "removed_watching_ticket": "Ticket {{id}} aus beobachteten Tickets entfernt",
  "clearing_ticket_status_changed": "Ticketstatus erfolgreich auf {{status}} geändert",
  "note_added": "Ticket-Notiz erfolgreich hinzugefügt",
  "internal_note_added": "Interne Notiz erfolgreich hinzugefügt",
  "sync_initialized": "Sync-Vorgang initialisiert",
  "sync_error_message": "Während der {{action}} ist ein Fehler aufgetreten. Möchten Sie den Sync-Vorgang erneut versuchen?",
  "CREATE_TICKET": "Erstellung eines Tickets",
  "ADD_TICKET_NOTE": "Hinzufügen einer Ticket-Notiz",
  "SET_TICKET_DATA": "Festlegen der Clearing-Daten",
  "SET_TICKET_RESOLVED": "Festlegen des Ticketstatus auf erledigt",
  "SET_TICKET_SEVERITY": "Ändern der Ticketpriorität",
  "SET_TICKET_STATUS": "Festlegen des Ticketstatus",
  "bulk_assignment_done": "Bulk-Zuweisung erfolgreich ausgeführt",
  "bulk_unassignment_done": "Bulk-Zuweisung erfolgreich aufgehoben",
  "lang_en": "Englisch",
  "reason_required": "Der Grund für die Statusänderung ist erforderlich!",
  "lang_de": "Deutsch",
  "mark_as_read": "Als gelesen markieren",
  "not_synced": "Nicht Synchronisiert",
  "bulk_options": "Bulk-Optionen",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "action_description": {
    "Initial": "Initial",
    "Start": "Bearbeitung starten",
    "Finish": "Lösung übermitteln",
    "Accept Resolution": "Lösung akzeptieren",
    "Reject Resolution": "Lösung ablehnen",
    "Cancel": "Abbrechen",
    "Archive": "Archivieren",
    "Request Information": "Informationen anfordern",
    "Add Information": "Informationen nachreichen",
    "Indicate Blockage": "Blockiert melden",
    "Resume Work": "Blockierung aufheben",
    "Unknown": "Unbekannt"
  },
  "new_issue_created": "Neues Ticket erstellt",
  "ticket_successfully_assigned_to_you": "Ticket erfolgreich zugewiesen",
  "name_field_must_not_be_empty": "Das Feld Name darf nicht leer sein!",
  "successfully_updated_template": "Erfolgreich aktualisierte Vorlage",
  "successfully_created_template": "Erfolgreich eine neue Vorlage erstellt",
  "update_template_name": "Name der Vorlage aktualisieren",
  "add_template_name": "Vorlagenname hinzufügen",
  "form_submission_error": "Fehler bei der Übermittlung eines Formulars",
  "review_the_form": "Bitte überprüfen Sie das Formular und füllen Sie alle erforderlichen Felder aus, bevor Sie es absenden.",
  "attach": "Anhängen",
  "add_clearing_ticket_data": "Clearing Ticket-Daten hinzufügen",
  "add_clearing_data_description_start": "Bitte machen Sie alle erforderlichen Angaben, um die Daten des Clearing-Tickets zu vervollständigen. Stellen Sie sicher, dass alle erforderlichen Felder mit einem Sternchen markiert sind",
  "add_clearing_data_description_end": "gekennzeichneten Pflichtfelder korrekt ausgefüllt sind. Diese Informationen helfen uns bei der Bearbeitung des Tickets entsprechend dem ausgewählten Ticketszenario.",
  "change_type": {
    "ticket_create": "Ticket erstellt",
    "note_add": "Notiz hinzugefügt",
    "internal_note_add": "Interne Notiz hinzugefügt",
    "status_change": "Status geändert",
    "severity_change": "Schweregrad geändert",
    "requested_resolution_date_change": "Zieltermin geändert",
    "data_change": "Daten geändert",
    "attachment_add": "Lösungsanhang hinzugefügt",
    "assignment_change": "Zuweisung geändert",
    "unknown": "Unbekannte Änderung"
  },
  "calendar": {
    "firstDayOfWeek": 1,
    "dayNames": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    "dayNamesShort": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    "dayNamesMin": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    "monthNames": [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ],
    "monthNamesShort": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    "today": "Heute",
    "clear": "Löschen"
  },
  "notification": {
    "ticket_created": "Ticket erstellt",
    "data_changed": "Daten geändert",
    "note_added": "Notiz hinzugefügt",
    "ticket_resolved": "Ticket gelöst",
    "severity_changed": "Schweregrad wurde geändert zu: {0}",
    "status_changed": "Status wurde geändert zu: {0}"
  },
  "internal_note": "Intern",
  "time_ago": {
    "just_now": "gerade eben",
    "minute_ago": "vor einer Minute",
    "minutes_ago": "vor {0} Minuten",
    "hour_ago": "vor einer Stunde",
    "hours_ago": "vor {0} Stunden",
    "day_ago": "vor einem Tag",
    "days_ago": "vor {0} Tagen"
  },
  "click_to_change_severity": "Klicken Sie auf , um den Schweregrad zu ändern",
  "ticket_exceeded_sla_resolution_time": "Frist abgelaufen",
  "ticket_exceeds_sla_warning_time_soon": "Frist läuft ab",
  "ticket_due_reached": "Frist läuft ab",
  "ticket_due_exceeded": "Frist abgelaufen",
  "partnership_management": "Management von Partnerschaften",
  "partnership_description": "Hier können Sie Partnerschaften und deren Spezifikationen einsehen und verwalten",
  "partnerships": "Partnerschaften",
  "create_partnership": "Schaffen Sie eine Partnerschaft",
  "specification_name": "Spezifikation Name",
  "partners": "Partner",
  "no_partnerships_found": "Keine Partnerschaften gefunden.",
  "edit_partnership": "Partnerschaft bearbeiten",
  "here_you_can_create_partnership": "Hier können Sie eine Partnerschaft eingehen",
  "here_you_can_edit_partnership": "Hier können Sie eine Partnerschaft bearbeiten",
  "partnership_specification": "Spezifikation der Partnerschaft",
  "partnership_identification": "Identifizierung der Partnerschaft",
  "partner_id": "Partner ID",
  "partner_name": "Partnername",
  "partner_characteristics": "Partner Merkmale",
  "characteristic_name": "Merkmal Name",
  "characteristic_value": "Merkmal Wert",
  "remove_characteristic": "Merkmal entfernen",
  "manage_partnership": "Verwalten der Partnerschaft",
  "here_you_can_manage_partnership": "Hier können Sie eine Partnerschaft verwalten",
  "add_recipients": "Empfänger hinzufügen",
  "email_partner_error": "Der E-Mail-Partner muss mindestens einen Empfänger haben! Drücken Sie die Eingabetaste, um den Empfänger zu speichern!",
  "invalid_email": "Ungültige E-Mail",
  "email_address": "E-Mail-Adresse",
  "delete_record_message": "Möchten Sie diesen Datensatz löschen?",
  "attachment_role_type": "Anhangs Typ",
  "ADDRESS_CHANGE": "Adressänderung",
  "EXCERPT_PROOF": "Auszugsnachweis",
  "PROOF": "Nachweis",
  "PHONE_NUMBER_LIST": "Telefonnummernliste",
  "HALF_YEARLY_REPORT": "Halbjahresbericht",
  "BNETZA_DOCUMENT": "BNetzA-Dokument",
  "BUILDER_SERVICE_INVOICE": "Bauunternehmer-Rechnung",
  "OTHER": "Sonstiges",
  "confirm_navigation": "Navigation bestätigen",
  "changes_will_be_lost": "Nicht gespeicherte Änderungen gehen verloren. Seite wirklich verlassen?",
  "nav_confirm_yes": "Verlassen",
  "nav_confirm_no": "Bleiben",
  "ticket_not_synced": "Dieses Ticket wurde nicht erfolgreich mit der Partnerplattform-Instanz synchronisiert. Fehlgeschlagene Aktion: {{action}}. Bitte synchronisieren Sie das Ticket, bevor Sie fortfahren.",
  "ticket_email_not_sent": "Die E-Mail-Benachrichtigung wurde nicht erfolgreich versendet. Fehlgeschlagene Aktion: {{action}}.",
  "resend_email": "E-Mail erneut senden",
  "default_recipients": "Standardempfänger je Hauptszenario",
  "apply_to_subscenarios": "Auf Unterszenarien anwenden",
  "inherit_from_group": "Vom Hauptszenario übernommen",
  "save_query": "Suche speichern",
  "load_query": "Suche laden",
  "load_saved_query": "Gespeicherte Suche laden",
  "select_saved_query": "Gespeicherte Suche auswählen:",
  "query_name": "Name der Suche",
  "enter_query_name": "Geben Sie einen Namen für die Suche ein",
  "no_saved_queries_found": "Keine gespeicherten Suchen gefunden",
  "delete_query": "Suche löschen",
  "load": "Laden",
  "query_deleted_successfully": "Suche erfolgreich gelöscht",
  "failed_to_load_saved_queries": "Gespeicherte Suchen konnten nicht geladen werden",
  "failed_to_delete_query": "Suche konnte nicht gelöscht werden",
  "export": "Exportieren",
  "attachments_help": "Maximal zulässige Dateigröße",
  "no_entries": "Keine Einträge verfügbar. Klicken Sie auf ",
  "add_entry_hint": ", um einen hinzuzufügen.",
  "download": "Herunterladen",
  "need_additional_help": "Benötigen Sie weitere Hilfe",
  "contact_support_team": "Bei Fragen, technischen Problemen oder Supportanfragen zur Clearing-Plattform wenden Sie sich bitte an das BITConEx-Supportteam unter",
  "additional_support": "Das Supportteam unterstützt Sie gerne bei Fragen zum Benutzerzugriff, Systemverhalten, den Konfigurationseinstellungen und anderen Problemen bei der Nutzung der Plattform.\n\nFür eine detaillierte Anleitung können Sie auch das vollständige Hilfehandbuch zur Clearing-Plattform herunterladen.",
  "invalid_file_size_summary": "{0} Ungültige Dateigröße,",
  "invalid_file_size_detail": "Maximal zulässige Dateigröße {0}.",
  "no_partner_light_configurations": "Keine Light-Partner-Konfigurationen gefunden.",
  "itu_code": "ITU-Code",
  "new_light_partner_config": "Neue Light-Partner-Konfiguration erstellen",
  "edit_light_partner_config": "Light-Partner-Konfiguration bearbeiten",
  "search_by_itu_code": "Suche nach ITU-Code",
  "search_by_email_address": "Suche nach E-Mail-Adresse",
  "are_you_lost": "Hast du dich verlaufen?",
  "page_not_found": "Entschuldigung, wir konnten die Seite nicht finden.",
  "back_to_home": "Zurück zur Startseite",
  "release_notes": {
    "empty_message": "Keine Versionshinweise verfügbar",
    "empty_description": "Schau später wieder vorbei für Updates und neue Funktionen.",
    "feature": "Funktion",
    "fix": "Fehlerbehebung",
    "improvement": "Verbesserung",
    "security": "Sicherheit",
    "breaking_change": "Inkompatible Änderung"
  },
  "input_needed_required_fields": "Eingabe erforderlich, bitte füllen Sie die Pflichtfelder (*) aus",
  "switch_to_dark_theme": "Zum dunklen Design wechseln",
  "switch_to_light_theme": "Zum hellen Design wechseln",
  "waiting_target_resolution": "Wartet auf Zielauflösung",
  "related": "Verknüpft",
  "related_ticket": "Verknüpftes Ticket",
  "resolve_target": "Ziel auflösen",
  "target_itu_code": "Ziel-ITU-Code",
  "select_target_organization": "Zielorganisation auswählen",
  "target_resolved_success": "Zielorganisation wurde erfolgreich aufgelöst",
  "no_target_organization_available": "Für dieses Ticket ist keine Zielorganisation verfügbar",
  "bulk_resolve_target": "Ziele gesammelt auflösen",
  "confirm_bulk_resolve_target": "Ziel für {{count}} ausgewählte Tickets auflösen?",
  "no_waiting_proxy_tickets_selected": "Keine wartenden Proxy-Tickets ausgewählt",
  "bulk_target_resolved_success": "{{count}} Tickets erfolgreich aufgelöst"
}
